import { render, staticRenderFns } from "./NewsItemJiangjin.vue?vue&type=template&id=f7cf6b12&scoped=true&"
import script from "./NewsItemJiangjin.vue?vue&type=script&lang=ts&"
export * from "./NewsItemJiangjin.vue?vue&type=script&lang=ts&"
import style0 from "./NewsItemJiangjin.vue?vue&type=style&index=0&id=f7cf6b12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7cf6b12",
  null
  
)

export default component.exports